import React from 'react';
import {
  Columns,
  Column,
  Card,
  SubTitle,
} from '@codeparva/ui-components-library';
import { JumbotronTypes } from '../../jumbotronTypes';
// import { Price } from './cardHelper/Price';
import { CTA } from './cardHelper/CTA';
import { weakKey } from '../../../../../../utilities/weakKey';
import { FontAwesomeIcon } from '../../../../../../utilities/iconLoader/FontAwesomeIcon';
import { CardFormattedHrs } from './cardHelper/CardFormattedHrs';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';

export const CardListOfCard = ({
  contactDetails,
  variant,
  cardWidth,
}: JumbotronTypes.ICard) => {
  const formatPhoneNumber = (phoneNumber: string) => {
    const contactNumber =
      phoneNumber &&
      phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (contactNumber !== null) {
      return !contactNumber[2]
        ? contactNumber[1]
        : `(${contactNumber[1]}) ${contactNumber[2]}${
            contactNumber[3] ? ` ${contactNumber[3]}` : ''
          }`;
    }
  };

  const { width } = useWindowDimensions();

  return (
    <Columns className="listOfCard">
      {contactDetails?.map(contactDetail => {
        return (
          <Column
            key={weakKey(contactDetail)}
            size={width >= 769 && width <= 1023 ? 'half' : 'one-third'}
            className="is-flex is-justify-content-center"
          >
            <Card
              className="cardListOfCard"
              style={{ width: `${cardWidth}px` || '360px' }}
            >
              <Card.Content>
                <Columns className="is-mobile">
                  <Column className="pb-1 is-flex">
                    <SubTitle
                      renderAs="h4"
                      className="SubTitle has-text-weight-bold mb-2"
                    >
                      {contactDetail.locationName}
                    </SubTitle>
                    {contactDetail?.contactNumber?.map(contact => (
                      <div
                        className="has-text-right pt-2 ml-2 "
                        key={weakKey(contact)}
                      >
                        {
                          <a href={contact.link}>
                            <FontAwesomeIcon
                              iconClassName={contact?.icon?.iconClassName!}
                              iconContextProps={{
                                className: `${`has-text-${contact?.icon
                                  ?.color || 'primary'}`}`,
                                style: {
                                  fontSize: contact?.icon?.size || 30,
                                },
                              }}
                            />
                          </a>
                        }
                      </div>
                    ))}
                  </Column>
                </Columns>
                <Columns>
                  {contactDetail?.address?.map(address => (
                    <Column
                      key={weakKey(address)}
                      className="py-1 ContactDetail"
                    >
                      <SubTitle renderAs="h4" size="6">
                        <a href={address.link} target="_blank">
                          {address.data}
                        </a>
                      </SubTitle>
                    </Column>
                  ))}
                </Columns>
                <Columns>
                  {contactDetail?.contactNumber?.map(contactNumber => (
                    <Column
                      key={weakKey(contactNumber)}
                      className="py-1 ContactDetail"
                    >
                      <SubTitle renderAs="h4" size="7">
                        <a href={contactNumber.link}>{`${formatPhoneNumber(
                          `${contactNumber.data}`
                        )}`}</a>
                      </SubTitle>
                    </Column>
                  ))}
                </Columns>
                <Columns className="mt-0">
                  <Column className="py-0">
                    {/* <Price
                      priceSection={contactDetail.priceSection}
                      variant={variant}
                    /> */}
                  </Column>
                </Columns>
                <Columns className="mb-0">
                  <Column>{contactDetails && <CardFormattedHrs />}</Column>
                </Columns>
                <CTA buttonText={contactDetail?.buttonText} variant={variant} />
              </Card.Content>
            </Card>
          </Column>
        );
      })}
    </Columns>
  );
};
